import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tui-call-kit",
  id: "tui-call-kit-id"
}
const _hoisted_2 = { class: "function-buttons" }

import Dialing from "./Dialing.vue";
import ControlPanel from "./ControlPanel.vue";
import CallingGroup from "./Calling-Group.vue";
import CallingC2CVideo from "./Calling-C2CVideo.vue";
import { status, isMinimized } from "../store";
import { STATUS } from "../constants";
import { TUICallKitServer } from "../index";
import MinimizeSVG from "../icons/minimize.vue";
import fullScreenSVG from "../icons/fullScreen.vue";
import { withDefaults, toRefs, watchEffect } from "vue";
import "../style.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'TUICallKit',
  props: {
    beforeCalling: null,
    afterCalling: null,
    onMinimized: null,
    onMessageSentByMe: null,
    allowedMinimized: { type: Boolean, default: false },
    allowedFullScreen: { type: Boolean, default: true },
    lang: { default: "zh-cn" }
  },
  setup(__props: any) {

const props = __props as { beforeCalling?: (...args: any[]) => void, afterCalling?: (...args: any[]) => void, onMinimized?: (...args: any[]) => void, onMessageSentByMe?: (...args: any[]) => void, allowedMinimized: boolean, allowedFullScreen: boolean, lang: string };


const { beforeCalling, afterCalling, onMinimized, onMessageSentByMe, allowedMinimized, allowedFullScreen, lang } =
  toRefs(props);
TUICallKitServer.setCallback({
  beforeCalling: beforeCalling && beforeCalling.value,
  afterCalling: afterCalling && afterCalling.value,
  onMinimized: onMinimized && onMinimized.value,
  onMessageSentByMe: onMessageSentByMe && onMessageSentByMe.value,
});
// watchEffect(() => {
//   TUICallKitServer.setLanguage(lang.value);
// })
function toggleMinimize() {
  if (document.fullscreenElement) {
    document.exitFullscreen();
  }
  TUICallKitServer.toggleMinimize();
}

function toggleFullscreen() {
  let elem = document.getElementById("tui-call-kit-id") as HTMLElement;
  if (!document.fullscreenElement) {
    elem.requestFullscreen().catch((err) => {
      alert(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
    });
  } else {
    document.exitFullscreen();
  }
}

return (_ctx: any,_cache: any) => {
  return (_unref(status) !== _unref(STATUS).IDLE)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (
          _unref(status) !== _unref(STATUS).IDLE &&
          _unref(allowedMinimized) === true &&
          _unref(status) !== _unref(STATUS).DIALING_C2C &&
          _unref(status) !== _unref(STATUS).DIALING_GROUP &&
          _unref(status) !== _unref(STATUS).BE_INVITED
        )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "minimize",
                onClick: toggleMinimize
              }, [
                _createVNode(MinimizeSVG)
              ]))
            : _createCommentVNode("", true),
          (_unref(allowedFullScreen) === true)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "minimize",
                onClick: toggleFullscreen
              }, [
                _createVNode(fullScreenSVG)
              ]))
            : _createCommentVNode("", true)
        ]),
        (
        _unref(status) === _unref(STATUS).BE_INVITED ||
        _unref(status) === _unref(STATUS).DIALING_C2C ||
        _unref(status) === _unref(STATUS).CALLING_C2C_AUDIO
      )
          ? (_openBlock(), _createBlock(Dialing, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(status) === _unref(STATUS).CALLING_C2C_VIDEO)
          ? (_openBlock(), _createBlock(CallingC2CVideo, { key: 1 }))
          : _createCommentVNode("", true),
        (
        _unref(status) === _unref(STATUS).DIALING_GROUP ||
        _unref(status) === _unref(STATUS).CALLING_GROUP_AUDIO ||
        _unref(status) === _unref(STATUS).CALLING_GROUP_VIDEO
      )
          ? (_openBlock(), _createBlock(CallingGroup, { key: 2 }))
          : _createCommentVNode("", true),
        (_unref(status) !== _unref(STATUS).IDLE)
          ? (_openBlock(), _createBlock(ControlPanel, { key: 3 }))
          : _createCommentVNode("", true)
      ], 512)), [
        [_vShow, !_unref(isMinimized)]
      ])
    : _createCommentVNode("", true)
}
}

})